import { gaId } from "./env";

// The Google analytics function (script loaded from index.html)
declare function ga(command: 'set', page: 'page', path: string): void;
declare function ga(command: 'send', pageview: 'pageview'): void;
declare function ga(command: 'send', event: 'event', category?: string, action?: string, label?: string, value?: number, fieldsObject?: Record<string, unknown>): void;
declare function ga(command: 'send', exception: 'exception', payload: { exDescription: string; exFatal: boolean }): void;

//
// Custom analytics class to act as a layer of abstraction so we can easily
// upgrade to a newer version of Google Analytics or even swap out for a
// different analytics provider without disturbing the entire codebase.
//
class Analytics {
    event(category?: string, action?: string, label?: string, value?: number) {
        if (!gaId) return;
        ga('send', 'event', category, action, label, value);
    }

    pageView(path: string) {
        if (!gaId) return;
        ga('set', 'page', path);
        ga('send', 'pageview');
    }

    exception(message: string, fatal: boolean) {
        if (!gaId) return;
        ga('send', 'exception', {
            exDescription: message,
            exFatal: fatal,
        });
    }
}

export const analytics = new Analytics();
